export default __webpack_public_path__ + "static/media/charging_normal.f400a938.svg";